import { render, staticRenderFns } from "./TagSelector.vue?vue&type=template&id=ef0fa198&scoped=true&"
import script from "./TagSelector.vue?vue&type=script&lang=js&"
export * from "./TagSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0fa198",
  null
  
)

export default component.exports